import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./theme/palette";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import FooterSection from "./components/FooterSection";

// Pages or sections
import Home from "./pages/Home"; 
import About from "./pages/About";
import Contact from "./pages/Contact"; 
import Services from "./pages/Services";





function App() {
  return (

    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Navbar />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services" element={<Services />} />


        </Routes>

        <FooterSection />
      </Router>
    </ThemeProvider>
  );
}

export default App;
